import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as Icon from 'react-feather';
import {
  createRedirect,
  getSession,
} from '../../../../utility/util/util.service';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import {
  setIsListOrdersModalOpen,
  setIsMoreSettingsModalOpen,
  setIsListPaymentMethodsModalOpen,
  setIsListAddressesModalOpen,
  setIsUserSettingsModalOpen,
  setListAddressesModalData,
} from '../../../../redux/modal/modal.actions';
import PropTypes from 'prop-types';
import { IntlContext } from '../../../../context/intl.context';
import classnames from 'classnames';
import { useAuth0, withAuth0 } from '@auth0/auth0-react';
import { history } from '../../../../history';
import {
  APP_SUPPORTED_LANGUAGES,
  config,
} from '../../../../configs/app.config';
import {
  BILLING_ADDRESS,
  DELIVERY_ADDRESS,
  ROUTE_ADMIN,
  ROUTE_DASHBOARD,
  ROUTE_DASHBOARD_ORDERS,
  ROUTE_DASHBOARD_SETTINGS,
  ROUTE_STORE,
} from '../../../../utility/constants';
import {
  deleteOnBehalfOfStoreOwner,
  handleChangePassword,
} from '../../../../utility/sb-api/sb-api.service';
import { fetchMe } from '../../../../redux/me/me.actions';
import {
  setAvailableOrderTypes,
  setCheckout,
  setSharedCarts,
  setTable,
  setTableCart,
} from '../../../../redux/store/store.actions';
import { notification } from '../../../../utility/notification/notification.service';

const MoreSettingsModal = ({
  isOpen,
  data,
  me,
  store,
  kiosk,

  setIsListPaymentMethodsModalOpen,
  setIsMoreSettingsModalOpen,
  setIsListOrdersModalOpen,
  setIsListAddressesModalOpen,
  setIsUserSettingsModalOpen,
  setListAddressesModalData,
  fetchMe,
  setTable,
  setSharedCarts,
  setTableCart,
  setCheckout,
  setAvailableOrderTypes,
}) => {
  const { logout, loginWithRedirect, isAuthenticated } = useAuth0() || {};
  const tableSession = getSession('tableSession');

  const closeModal = () => setIsMoreSettingsModalOpen(false);

  const handleLogin = () => {
    loginWithRedirect({ redirectUri: createRedirect() });
  };

  const handleLogout = () => {
    logout({ returnTo: createRedirect() });
  };

  const handleRegister = () => {
    const guestToken = localStorage.getItem('guestToken');
    if (guestToken) {
      // adopt guest automatically if there is a guestToken
      localStorage.setItem('adoptGuestMode', 'yes');
    }

    loginWithRedirect({
      screen_hint: 'signup',
      redirectUri: createRedirect(),
    });
  };

  const handleGoToDashboard = () => {
    closeModal();
    history.push(ROUTE_DASHBOARD);
  };

  const handleGoToSettings = () => {
    closeModal();
    history.push(ROUTE_DASHBOARD_SETTINGS);
  };

  const handleGoToMenu = () => {
    closeModal();
    history.push(`${ROUTE_STORE}/${store?.slug}`);
  };

  const handleLeaveTable = () => {
    localStorage.removeItem('tableSession');
    setTable(null);
    setSharedCarts([]);
    setCheckout(null);
    setTableCart(null);
    setAvailableOrderTypes(null);
    notification('success', 'leaveTableNotification');
    closeModal();
  };

  const handleOpenListOrdersModal = () => {
    closeModal();
    me?.isStoreOwner
      ? history.push(ROUTE_DASHBOARD_ORDERS)
      : setIsListOrdersModalOpen(true);
  };
  const handleGoToAdminArea = () => {
    closeModal();
    history.push(ROUTE_ADMIN);
  };

  const handleDeleteOnBehalfOfStore = () => {
    deleteOnBehalfOfStoreOwner(
      me?.requester?.employeeProfile?.store,
      handleGoToAdminArea,
      fetchMe,
    );
  };

  return (
    <>
      <ModalSheet isOpen={isOpen} closeModal={closeModal}>
        <div className="pb-1">
          {me?.isAdmin && (
            <>
              <div
                className="d-flex justify-content-center align-items-center"
                onClick={handleGoToAdminArea}
              >
                <Icon.Monitor
                  data-testid="adminMenu"
                  size={20}
                  className="primary"
                />
                <span className="ml-1 font-medium-1">
                  <FormattedMessage id="Admin" />
                </span>
              </div>
              <hr />
            </>
          )}

          {isAuthenticated && me?.isStoreOwner && (
            <>
              <div
                className="d-flex justify-content-center align-items-center"
                onClick={handleGoToDashboard}
              >
                <Icon.Grid
                  data-testid="dashboardMenu"
                  size={20}
                  className="primary"
                />
                <span className="ml-1 font-medium-1">
                  <FormattedMessage id="goToDashboard" />
                </span>
              </div>
              <hr />
            </>
          )}

          {!kiosk && (
            <>
              {isAuthenticated ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => {
                    me?.onBehalfOfStore
                      ? handleDeleteOnBehalfOfStore()
                      : handleLogout();
                  }}
                >
                  <Icon.LogOut
                    data-testid="logoutFromStore"
                    size={20}
                    className="primary"
                  />
                  <span
                    className="ml-1 font-medium-1"
                    data-testid="logut_button"
                  >
                    <FormattedMessage id="logout" />
                  </span>
                </div>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => handleLogin()}
                >
                  <Icon.LogIn
                    data-testid="loginOnStore"
                    size={20}
                    className="primary"
                  />
                  <span className="ml-1 font-medium-1">
                    <FormattedMessage id="login" />
                  </span>
                </div>
              )}
              <hr />

              {!isAuthenticated && (
                <>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    onClick={handleRegister}
                  >
                    <Icon.UserPlus
                      data-testid="registerOnStore"
                      size={20}
                      className="primary"
                    />
                    <span className="ml-1 font-medium-1">
                      <FormattedMessage id="registerNow" />
                    </span>
                  </div>
                  <hr />
                </>
              )}

              {tableSession && (
                <>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    onClick={handleLeaveTable}
                  >
                    <Icon.LogOut
                      data-testid="leaveTableButton"
                      size={20}
                      className="primary"
                    />
                    <span className="ml-1 font-medium-1">
                      <FormattedMessage id="leaveTableLabel" />
                    </span>
                  </div>
                  <hr />
                </>
              )}

              {me && (
                <>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    onClick={handleOpenListOrdersModal}
                  >
                    <Icon.ShoppingBag
                      data-testid="ordersButton"
                      size={20}
                      className="primary"
                    />
                    <span className="ml-1 font-medium-1">
                      <FormattedMessage id="orders" />
                    </span>
                  </div>
                  <hr />

                  {me?.isStoreOwner ? (
                    <>
                      <div
                        className="d-flex justify-content-center align-items-center"
                        onClick={handleGoToSettings}
                      >
                        <Icon.Settings
                          data-testid="settings"
                          size={20}
                          className="primary"
                        />
                        <span className="ml-1 font-medium-1">
                          <FormattedMessage id="settings" />
                        </span>
                      </div>
                      <hr />
                      <div
                        className="d-flex justify-content-center align-items-center"
                        onClick={handleGoToMenu}
                      >
                        <Icon.BookOpen
                          data-testid="menuButton"
                          size={20}
                          className="primary"
                        />
                        <span className="ml-1 font-medium-1">
                          <FormattedMessage id="menu" />
                        </span>
                      </div>
                      <hr />
                    </>
                  ) : (
                    <>
                      <div
                        className="d-flex justify-content-center align-items-center"
                        onClick={() => setIsListPaymentMethodsModalOpen(true)}
                      >
                        <Icon.CreditCard
                          data-testid="paymentMethodsButton"
                          size={20}
                          className="primary"
                        />
                        <span className="ml-1 font-medium-1">
                          <FormattedMessage id="paymentMethodsTitle" />
                        </span>
                      </div>
                      <hr />
                      <div
                        className="d-flex justify-content-center align-items-center"
                        onClick={() => {
                          setListAddressesModalData({ type: BILLING_ADDRESS });
                          setIsListAddressesModalOpen(true);
                        }}
                      >
                        <Icon.Mail
                          data-testid="billingAdressesButton"
                          size={20}
                          className="primary"
                        />
                        <span className="ml-1 font-medium-1">
                          <FormattedMessage id="billing_addresses" />
                        </span>
                      </div>
                      <hr />
                      <div
                        className="d-flex justify-content-center align-items-center"
                        onClick={() => {
                          setListAddressesModalData({ type: DELIVERY_ADDRESS });
                          setIsListAddressesModalOpen(true);
                        }}
                      >
                        <Icon.Truck
                          data-testid="deliveryAdressesButton"
                          size={20}
                          className="primary"
                        />
                        <span className="ml-1 font-medium-1">
                          <FormattedMessage id="delivery_addresses" />
                        </span>
                      </div>
                      <hr />
                    </>
                  )}
                </>
              )}
            </>
          )}
          {!kiosk && (me?.isGuest || me?.isUser) && (
            <>
              <div
                className="d-flex justify-content-center align-items-center"
                onClick={() => {
                  setIsUserSettingsModalOpen(true);
                }}
              >
                <Icon.Settings size={20} className="primary" />
                <span className="ml-1 font-medium-1">
                  <FormattedMessage id="userSettingsModalTitle" />
                </span>
              </div>
              <hr />
            </>
          )}
          <div
            className="d-flex justify-content-around align-content-center px-1"
            style={{ height: '20px' }}
          >
            <IntlContext.Consumer>
              {(context) =>
                APP_SUPPORTED_LANGUAGES.map((language) => {
                  const iconName = language.startsWith('en')
                    ? 'us'
                    : language.substring(0, 2);

                  return (
                    <img
                      key={language}
                      onClick={() => {
                        context.switchLocale(language);
                      }}
                      className={classnames({
                        opacity4: context.locale.substring(0, 2) !== language,
                      })}
                      style={{ borderRadius: '5px' }}
                      src={`/assets/icons/country-flags/${iconName}.svg`}
                    />
                  );
                })
              }
            </IntlContext.Consumer>
          </div>

          <div className="d-flex justify-content-around align-content-center mt-1">
            <span className="font-small-2">
              v{config.version} - {config.commitSha}
            </span>
          </div>
        </div>
      </ModalSheet>
    </>
  );
};

MoreSettingsModal.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.object,
  me: PropTypes.object,
  intl: PropTypes.object,
  auth0: PropTypes.object,
  setIsMoreSettingsModalOpen: PropTypes.func,
  setIsListOrdersModalOpen: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isMoreSettingsModalOpen,
  data: state.modals.listMoreSettingsModalData,
  me: state.me.me,
  store: state.store.store,
  kiosk: state.store.kiosk,
  table: state.store.table,
  availableOrderTypes: state.store.availableOrderTypes,
});

export default connect(mapStateToProps, {
  setIsMoreSettingsModalOpen,
  setIsListOrdersModalOpen,
  setIsListPaymentMethodsModalOpen,
  setIsListAddressesModalOpen,
  setIsUserSettingsModalOpen,
  setListAddressesModalData,
  fetchMe,
  setTable,
  setTableCart,
  setSharedCarts,
  setCheckout,
  setAvailableOrderTypes,
})(MoreSettingsModal);
